export const getTargetForLink = href => /^(https?:)?\/\//.test(href) ? '_blank' : '_self'